import { hasCapability, type User } from "../base";

export const contractorInternalDetailFields = {
  read: (user: User) => hasCapability(user, "contractorInternalDetailFields.read"),
  update: (user: User) => hasCapability(user, "contractorInternalDetailFields.update"),
};
